import { connect } from 'react-redux';
import { component as Category } from './index';
import * as actions from './actions';
import * as filterActions from '../filter/actions';
import { loadUserRecommendations } from 'components/recommendation/actions';

class SearchResults extends Category {
  constructor(props) {
    super(props);
  }

  loadList(props) {
    const searchQuery = props.match.params.searchQuery;
    return this.props
      .loadCategory({ searchQuery })
      .then(() => this.props.getAvailableFilters())
      .then(() => this.props.updateFilteredProducts())
      .then(() => {
        this._track();
        return null;
      });
  }
}

function mapStateToProps(state) {
  return {
    ...state.category,
    products: state.filter.products,
    filtersLoading: state.filter.loading,
    count: state.filter.count,
    selected: state.filter.selected,
    size: state.filter.size,
    address: state.address,
    user: state.login.user,
    userRecommendations: state.recommendation.userRecommendations
  };
}

export default connect(mapStateToProps, {
  ...actions,
  resetFilters: filterActions.resetFilters,
  syncWithQueryParams: filterActions.syncWithQueryParams,
  updateFilteredProducts: filterActions.updateFilteredProducts,
  getAvailableFilters: filterActions.getAvailableFilters,
  loadUserRecommendations
})(SearchResults);



// WEBPACK FOOTER //
// ./shared/components/category/searchResults.js